export var MessageType;
(function (MessageType) {
    MessageType[MessageType["info"] = 0] = "info";
    MessageType[MessageType["warning"] = 1] = "warning";
    MessageType[MessageType["error"] = 2] = "error";
})(MessageType || (MessageType = {}));
